import isBase64 from './isBase64';

export default function checkFontUrl(src) {
  if (isBase64(src)) {
    return src;
  }

  return '\'' + src + '\'';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/node_modules/fela-utils/es/checkFontUrl.js
// module id = 678
// module chunks = 0